import { Component, OnInit } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/msg-default.svg',
})
export class MsgDefaultComponent {}
